class JSONSet extends Set {
  constructor(iterable) {
    super(iterable);
  }
  toJSON() {
    return [...this];
  }
}
module.exports = JSONSet;
